/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
import './verticals/rst_release_manager_features';
import './next_gen_settings';
import './modifier_sequencing_settings';
import './checkout_convergence_item_details_settings';
import './checkout_convergence_item_grid_settings';
import './penny_round_up_settings';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "releasemanager": {
                            "nested": {
                              "ReleaseManagerSettings": {
                                "fields": {
                                  "rstReleaseManagerFeatures": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.releasemanager.verticals.RSTReleaseManagerFeatures",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "nextGenSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.releasemanager.NextGenSettings",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "modifierSequencingSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.releasemanager.ModifierSequencingSettings",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "checkoutConvergenceItemDetailsSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.releasemanager.CheckoutConvergenceItemDetailsSettings",
                                    "id": 4,
                                    "rule": "optional"
                                  },
                                  "checkoutConvergenceItemGridSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.releasemanager.CheckoutConvergenceItemGridSettings",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "pennyRoundUpSettings": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.releasemanager.PennyRoundUpSettings",
                                    "id": 6,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.releasemanager?.nested?.ReleaseManagerSettings) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE ReleaseManagerSettings @ squareup/devicesettings/profiles/v2/model/settings/releasemanager/release_manager_settings.proto at 24:1
 */
export const ReleaseManagerSettings = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.releasemanager.ReleaseManagerSettings');
fixType(ReleaseManagerSettings);
Builder.createAndAttachToType(ReleaseManagerSettings);